import {useClientCart} from '../../core/clientProvider'
import {useResponsibleCart} from '../../core/responsibleProvider'
import {ClientSearch} from './Search'
import {ResponsibleSearch} from './Search/responsible'
import {PersonInfo} from '../../../../../components/Person/PersonInfo'
import {useCart} from '../../core/cartProvider'
import {TokenModalSale} from '../Token/modalToken'
import useAuthorization from '../../../../../hooks/useAuthorization'

export const Client = () => {
  const {
    client,
    isRestrictClient,
    isRestrictClientApproved,
    setIsRestrictClientApproved,
    openRestrictClientTokenModal,
    setOpenRestrictClientTokenModal,
  } = useClientCart()
  const {responsible} = useResponsibleCart()
  const {budgetData, changeStateToken, token} = useCart()

  const hasBudget = budgetData != null
  const isAuthorizedToApproveRestrictClient = useAuthorization('sales.approve_restrict_client')

  return (
    <>
      {client == null && <ClientSearch />}
      {client != null && (
        <PersonInfo
          person={client}
          responsible={false}
          provider={useClientCart}
          index={0}
          hasBudget={hasBudget}
          source='SALE'
        />
      )}
      {client != null && isRestrictClient && !isRestrictClientApproved && !isAuthorizedToApproveRestrictClient && (
        <div className='alert alert-warning d-flex align-items-center p-3 mb-4'>
          <span className='fw-bold'>
            Cliente restrito — aguardando autorização do gestor para prosseguir.
          </span>
          <button
            type='button'
            className='btn btn-sm btn-warning ms-auto'
            onClick={() => setOpenRestrictClientTokenModal(true)}
          >
            Solicitar autorização
          </button>
        </div>
      )}
      {!responsible &&
        client &&
        client.physicalPerson &&
        client.physicalPerson.birthDate &&
        client.physicalPerson.age < 18 && <ResponsibleSearch />}
      {responsible && (
        <PersonInfo
          person={responsible}
          responsible={true}
          provider={useResponsibleCart}
          index={0}
          hasBudget={hasBudget}
          source='SALE'
        />
      )}
      {openRestrictClientTokenModal && (
        <TokenModalSale
          tokenAction='sales.approve_restrict_client'
          action={() => {
            setIsRestrictClientApproved(true)
          }}
          close={() => setOpenRestrictClientTokenModal(false)}
        />
      )}
    </>
  )
}
